import { CacheKey } from "@mirage/service-typeahead-search/service/typeahead-cache";
import {
  SourceId,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";
import * as wrappers from "@mirage/service-typeahead-search/service/utils/wrappers";
import * as rx from "rxjs";

import * as primitives from "@mirage/service-typeahead-search/service/primitives";
import {
  filterRecommendations,
  tagAndInjectHitsFactory,
} from "@mirage/service-typeahead-search/service/utils/recommendation-helpers";
import type { Recommendation } from "@mirage/shared/search/recommendation";
import { getResultSection } from "../utils/section-mapper";
import { getSourceLimit } from "../utils/source-helpers";

const FILTER_RESULT_LIMIT = 200;

export const raw: typeahead.TaggedSearch = (query, mode, options) => {
  return rx.defer(() => {
    const { config, cache, grossLimit, sectionLimit } = options;

    const omniboxResults = cache.all(
      CacheKey.OmniboxRecommendations,
    ) as Recommendation<"omnibox">[];

    const typeaheadResults = cache.all(
      CacheKey.Recommendations,
    ) as Recommendation[];

    // If omnibox is enabled but results are empty, use typeahead results
    // This is to ensure that for users transitioning to Omnibox they don't experience
    // a blank state
    // TODO (P1): When Omnibox is launched for Desktop/Launcher we will remove this
    // and the dcsGetTypeaheadRecommendations endpoint will be removed
    const isUsingOmniboxResults =
      config.isOmniboxEnabled && omniboxResults.length > 0;

    const gatedResults = isUsingOmniboxResults
      ? omniboxResults
      : typeaheadResults;

    const recommendations = filterRecommendations(
      gatedResults,
      query,
      mode,
      options,
      {
        filterResultLimit: FILTER_RESULT_LIMIT,
      },
    );

    const sourceLimit = getSourceLimit(
      typeahead.ResultType.Recommendation,
      query,
      mode,
      config,
      grossLimit,
      sectionLimit,
    );

    const sectionId = getResultSection(
      typeahead.ResultType.Recommendation,
      mode,
      query,
      config,
    );

    const tagAndInjectHits = tagAndInjectHitsFactory(
      primitives.recommendation,
      (result) => result.uuid,
      sourceLimit,
      sectionId,
    );

    return rx.of(tagAndInjectHits(recommendations, query, mode, options));
  });
};

export const search = wrappers.wrapped(SourceId.Recommendations, raw);
